import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=8ef1b9e6&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=js&"
export * from "./Dialog.vue?vue&type=script&lang=js&"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=8ef1b9e6&prod&lang=less&scoped=true&"
import style1 from "./Dialog.vue?vue&type=style&index=1&id=8ef1b9e6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef1b9e6",
  null
  
)

export default component.exports